// Angular
import { Component, Input, OnInit } from '@angular/core';

export interface Timeline2Data {
	date: string;
	remark: string;
	actionType?: string;
	attachment?: string;
}

@Component({
	selector: 'kt-timeline2',
	templateUrl: './timeline2.component.html',
	styleUrls: ['./timeline2.component.scss']
})
export class Timeline2Component implements OnInit {
	// Public properties
	@Input() data: Timeline2Data[];

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit() {
		if (!this.data) {
			this.data = [
				{
					date: '10:00',
					actionType: 'fa fa-genderless kt-font-danger',
					remark: 'Lorem ipsum dolor sit amit,consectetur eiusmdd tempor\n' +
						'incididunt ut labore et dolore magna',
				},
				{
					date: '12:45',
					actionType: 'fa fa-genderless kt-font-success',
					remark: 'AEOL Meeting With',
					attachment: '\n' +
						'<a href="$event.preventDefault();"><img src="./assets/media/users/100_4.jpg" title="" alt=""></a>' +
						'<a href="$event.preventDefault();"><img src="./assets/media/users/100_13.jpg" title="" alt=""></a>' +
						'<a href="$event.preventDefault();"><img src="./assets/media/users/100_11.jpg" title="" alt=""></a>' +
						'<a href="$event.preventDefault();"><img src="./assets/media/users/100_14.jpg" title="" alt=""></a>'
				},
				{
					date: '14:00',
					actionType: 'fa fa-genderless kt-font-brand',
					remark: 'Make Deposit <a href="$event.preventDefault();" class="kt-link kt-link--brand kt-font-bolder">USD 700</a> To ESL.',
				},
				{
					date: '17:00',
					actionType: 'fa fa-genderless kt-font-info',
					remark: 'Placed a new order in <a href="$event.preventDefault();" class="kt-link kt-link--brand kt-font-bolder">SIGNATURE MOBILE</a> marketplace.',
				},
				{
					date: '16:00',
					actionType: 'fa fa-genderless kt-font-brand',
					remark: 'Lorem ipsum dolor sit amit,consectetur eiusmdd tempor<br>' +
						'incididunt ut labore et dolore magna elit enim at minim<br>' +
						'veniam quis nostrud',
				},
				{
					date: '17:00',
					actionType: 'fa fa-genderless kt-font-danger',
					remark: 'Received a new feedback on <a href="$event.preventDefault();" class="kt-link kt-link--brand kt-font-bolder">FinancePro App</a> product.',
				},
			];
		}
	}
}
